import {
  DownloadPrescriptionFileParams,
  PrescriptionStoreT,
  PrescriptionT,
  PrescriptionCreatePropsT,
} from "@interfaces/prescriptions";

import Fetcher from "@http/fetcher";
import { ResCallback } from "@interfaces/common";

class PrescriptionService {
  static async getAll(
    companyId: number | undefined,
    offset: number,
    limit: number,
    count: boolean | undefined,
    user: number | undefined,
    cb: ResCallback<PrescriptionStoreT>
  ) {
    try {
      const res = await Fetcher.modified.get<PrescriptionStoreT>(
        "/prescriptions",
        {
          params: {
            companyId,
            offset,
            limit,
            count,
            user,
          },
        }
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }

  static async getOne(
    id: number,
    cb: ResCallback<PrescriptionT>
  ) {
    try {
      const res = await Fetcher.modified.get<PrescriptionT>(`/prescriptions/${id}`);

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }

  static async create(data: PrescriptionCreatePropsT, cb: ResCallback<PrescriptionT>) {
    try {
      const res = await Fetcher.modified.post<PrescriptionT>(
        "/prescriptions",
        data
      );

      if (res.status === 201) {
        cb(null, res);
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }

  static async update(
    id: number,
    data: PrescriptionCreatePropsT,
    cb: ResCallback<PrescriptionT>
  ) {
    try {
      const res = await Fetcher.modified.patch<PrescriptionT>(
        `/prescriptions/${id}`,
        data
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }

  static async markAsCompleted(
    id: number,
    checked: boolean,
    cb: ResCallback<string>
  ) {
    try {
      const res = await Fetcher.modified.post<string>(
        `/prescriptions/${id}/mark`,
        {
          checked,
        }
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }

  static async delete(id: number, cb: ResCallback<string>) {
    try {
      const res = await Fetcher.modified.delete<string>(`/prescriptions/${id}`);

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }

  static async send(id: number, cb: ResCallback<string>) {
    try {
      const res = await Fetcher.modified.post<string>(`/prescriptions/${id}/send`);

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }
}

export const prescriptionService = {
  async downloadFile({ companyId, fileName }: DownloadPrescriptionFileParams) {
    const resp = await Fetcher.get<Blob>(
      `/companies/${companyId}/prescriptions/${fileName}/download`,
      {
        responseType: "blob",
      }
    );

    return resp.data;
  },
};

export default PrescriptionService;
